import { Property } from "../../types/Property.interface";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";

import { apiClient } from "../../utils/apiClient";
import useStore, { StoreState } from "../../context/useStore";

const Cover = dynamic(() => import("./Cover"), {
  suspense: true,
});
const Body = dynamic(() => import("./Body"), {
  suspense: true,
});

interface CardProps {
  property: Property;
}

const Card: React.FC<CardProps> = ({ property }) => {
  const auth = useStore((state: StoreState) => state.auth);
  const setDialog = useStore((state: StoreState) => state.setDialog);
  const setVerify = useStore((state: StoreState) => state.setVerify);
  return (
    <Link target="_blank" href={`/propertydetails/${property.Slug}`}>
      <a
        onClick={async (e) => {
          if (property.Lock === true) {
            if (!auth.login) {
              e.preventDefault();
              e.stopPropagation();
              setDialog({
                closable: true,
                open: true,
              });
              return;
            }
            if (auth.login && auth.verify == false) {
              e.preventDefault();
              e.stopPropagation();

              const res: Response = await apiClient.post(
                "/api/v1/auth/email-verify"
              );
              if (res.ok) {
                setVerify({
                  closable: true,
                  open: true,
                });
              }
              return;
            }
          }
        }}
        className={`border block border-gray-300 cursor-pointer rounded-md hover:rounded-none transition-all duration-300 ease-in-out bg-white min-w-full min-h-full overflow-hidden`}
      >
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <Cover
            ListPrice={property.ListPrice}
            alt={property.UnparsedAddress || ""}
            src={property.Image}
            Lock={property.Lock || false}
          />
        </Suspense>

        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <Body property={property} />
        </Suspense>
      </a>
    </Link>
  );
};

export default Card;
